export const FEATURE_FLAGS_FUSE_OPTIONS = {
	keys: ['feature', 'description'],
	threshold: 0.2,
};

export const featureFlagUserLabel = (user) => {
	if (user?.name && user.name !== '-') return user.name;
	return user?.email || '';
};
